export default __webpack_public_path__ + "static/media/customer1.ab616ee3.svg";